import { render, staticRenderFns } from "./LabelButtonInput.vue?vue&type=template&id=367f814a&"
import script from "./LabelButtonInput.vue?vue&type=script&lang=ts&"
export * from "./LabelButtonInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports